import { render, staticRenderFns } from "./RuleFormulas.vue?vue&type=template&id=1701644e"
import script from "./RuleFormulas.vue?vue&type=script&lang=js"
export * from "./RuleFormulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports